<template>
    <div style="display: flex; flex-direction: column; gap: 12px; padding: 10px">
        <div style="display: flex; flex-direction: row; justify-content: end">
            <v-btn color="primary" @click="addHourToArray">{{ $t('add') }}</v-btn>
        </div>
        <div style="display: flex; flex-direction: column; gap: 4px">
            <div style="display: flex; flex-direction: row; gap: 8px;" v-for="item in courseHourList" :key="item.id">
                <v-select dense outlined v-model="item.classLevel" :items="classLevel" label="Уровень класса"/>
                <v-text-field dense outlined v-model="item.hours" label="Часы"/>
                <v-btn icon color="red" @click="deleteHour(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CourseHourDialog',
  props: {
    courseHourList: Array,
    classLevel: Array
  },
  methods: {
    addHourToArray () {
      this.$emit('addHourToArray')
    },
    deleteHour (item) {
      this.$emit('deleteHour', item)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
